import { Roles } from '../_models';
import { Ship } from '../_models/ship';

export enum ErrorCode {
  ResourceNotFound = '0000',
  PassengerNotFound = '0001',
  SlotNotFound = '0002',
  RestaurantNotFound = '0003',
  CompanionNotFound = '0004',
  AutologinFail = '0005',
  MissingPassengerInformation = '0006',
  SlotAlreadyFull = '0007',
  FailedReservation = '0008',
  UnauthorizedPassengerAccess = '0009',
}

export class Constants {
  public static TITLE_INFO = 'INFO!';
  public static TITLE_ERROR = 'ERROR!';
  public static TITLE_WARNING = 'WARNING!';
  public static TITLE_SUCCESS = 'SUCCESS!';
  public static TITLE_OFFLINE = 'IS OFFLINE!';

  static ErrorMessages = {
    ErrorCodes: {
      [ErrorCode.ResourceNotFound]: 'errors.resource_not_found',
      [ErrorCode.PassengerNotFound]: 'errors.passenger_not_found',
      [ErrorCode.SlotNotFound]: 'errors.slot_not_found',
      [ErrorCode.RestaurantNotFound]: 'errors.restaurant_not_found',
      [ErrorCode.CompanionNotFound]: 'errors.companion_not_found',
      [ErrorCode.AutologinFail]: 'errors.autologin_fail',
      [ErrorCode.MissingPassengerInformation]:
        'errors.missing_passenger_information',
      [ErrorCode.SlotAlreadyFull]: 'errors.slot_already_full',
      [ErrorCode.FailedReservation]: 'errors.failed_reservation',
      [ErrorCode.UnauthorizedPassengerAccess]:
        'errors.unauthorized_passenger_access',
    } as const,

    getTranslationKey(code: string, defaultKey = 'errors.generic'): string {
      return code in this.ErrorCodes
        ? this.ErrorCodes[code as keyof typeof this.ErrorCodes]
        : defaultKey;
    },
  };

  public static readonly SHIPS: Ship[] = [
    { id: 'DE', name: 'Costa Deliziosa' },
    { id: 'DI', name: 'Costa Diadema' },
    { id: 'FA', name: 'Costa Favolosa' },
    { id: 'FO', name: 'Costa Fortuna' },
    { id: 'FS', name: 'Costa Fascinosa' },
    { id: 'PA', name: 'Costa Pacifica' },
    { id: 'SE', name: 'Costa Serena' },
    { id: 'SM', name: 'Costa Smeralda' },
    { id: 'TO', name: 'Costa Toscana' },
  ];

  static Auth = class {
    public static USER_KEY = 'user';
    public static ENV_KEY = 'environment';
  };

  static Storager = class {
    public static USER_KEY = 'user';
    public static EVENT: string = 'event';
    public static PROFILES: string = 'profiles';
    public static MESSAGE: string = 'message';
    public static RESERVATION: string = 'reservation';
    public static OLD_RESERVATION: string = 'old_reservation';
    public static NEW_RESERVATIONS: string = 'new_reservations_uuid';
    public static CURRENT_USER: string = 'currentUser';
    public static LANG: string = 'lang';
    public static SHIPID: string = 'shipId';
    public static RESTAURANT: string = 'restaurant';
    public static COMPANIONS: string = 'companions';
    public static SLOT: string = 'slot';
    public static AUTOLOGIN: string = 'autologin';
    public static PHONE_NUMBER: string = 'phone_number';
  };

  static Routing = class {
    public static LOGIN = {
      label: 'Login',
      path: 'login',
      routerLink: ['/login'],
    };
    public static LANDING = {
      label: 'Landing',
      path: 'landing',
      routerLink: ['/landing'],
    };
    public static HOME = { label: 'Home', path: 'home', routerLink: ['/home'] };
    public static SELECT_USER = {
      label: 'Select user',
      path: 'select-user',
      routerLink: ['/select-user'],
    };
    public static CALENDAR = {
      label: 'Calendar',
      path: 'calendar',
      routerLink: ['/calendar'],
    };
    public static SUMMARY = {
      label: 'Summary',
      path: 'summary',
      routerLink: ['/summary'],
    };
    public static COMPLETE_RESERVATION = {
      label: 'Complite Reservation',
      path: 'complete-reservation',
      routerLink: ['/complete-reservation'],
    };
    public static NOT_FOUND = {
      label: 'Not Found',
      path: 'not-found',
      routerLink: ['/not-found'],
    };
  };

  // Add new Routes here
  static canAccess(roles: Roles[], route: any) {
    return (
      route.roles.find((role: Roles) => {
        return roles.includes(role);
      }) != undefined
    );
  }

  static getRoute(path: string) {
    path = '/' + path;
    return Object.entries(Constants.Routing).find(([key, value]) => {
      return value.routerLink[0] == path;
    });
  }
}
